import _ from 'lodash';
import { saveUserCredentials } from './../../services/auth';
import {
  REGISTER_USER,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAILURE,
  COMPLETE_REGISTRATION,
  COMPLETE_REGISTRATION_SUCCESS,
  COMPLETE_REGISTRATION_FAILURE,
  POLL_EMAIL_VERIFICATION,
  POLL_EMAIL_VERIFICATION_SUCCESS,
  POLL_EMAIL_VERIFICATION_FAILURE,
  STOP_POLL_EMAIL_VERIFICATION,
  RESEND_EMAIL_VERIFICATION,
  RESEND_EMAIL_VERIFICATION_SUCCESS,
  RESEND_EMAIL_VERIFICATION_FAILURE,
  RESEND_EMAIL_COOLDOWN_TICK,
  RESEND_EMAIL_COOLDOWN_EXPIRE,
  FETCH_PROFILE_FOR_COMPLETE_REGISTRATION,
  FETCH_PROFILE_FOR_COMPLETE_REGISTRATION_SUCCESS,
  FETCH_PROFILE_FOR_COMPLETE_REGISTRATION_FAILURE,
  INIT_COMPLETE_REGISTRATION,
  FETCH_ADDRESSES,
  FETCH_ADDRESSES_SUCCESS,
  FETCH_ADDRESSES_FAILURE,
  SELECT_ADDRESS_SUCCESS,
  SELECT_ADDRESS_FAILURE,
  RESET_AUTOCOMPLETE,
} from '../constants';

const defaultState = {
  isFetching: false,
  addressAutocompleteIsFetching: false,
  addresses: [],
  selectedAddress: false,
  selectedAddressParsed: {},
  isRegistered: false,
  registrationFailed: false,
  registrationSuccess: false,
  addressErrorDetail: false,
  duplicatedEmail: '',
  verificationLink: null,
  emailVerified: false,
  isPollingEmail: false,
  isResendingEmail: false,
  resendEmailMessage: '',
  resendEmailMessageIsError: false,
  resendCooldownRemaining: 0,
  profileFields: null,
  profilePrefillFailed: false,
  guardChecking: true,
  guardReady: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case REGISTER_USER:
    case COMPLETE_REGISTRATION:
      return {
        ...state,
        isFetching: true,
        registrationFailed: false,
      };
    case REGISTER_USER_SUCCESS:
      const {
        accessToken,
        identityToken,
        refreshToken,
        expiresIn,
      } = action.payload;
      saveUserCredentials({
        accessToken,
        identityToken,
        refreshToken,
        expiresIn,
      });
      return {
        ...state,
        isRegistered: true,
        isFetching: false,
        registrationSuccess: true,
        registrationFailed: false,
        errorDetail: false,
        selectedAddress: false,
      };
    case REGISTER_USER_FAILURE:
      const errorDetail = _.get(action.payload, 'errorDetail', false);
      const statusCode = _.get(action.payload, 'statusCode', false);
      const duplicatedEmail = _.get(action.payload, 'duplicatedEmail', false);
      return {
        ...state,
        isFetching: false,
        registrationFailed: true,
        errorDetail,
        statusCode,
        duplicatedEmail,
      };
    case COMPLETE_REGISTRATION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        registrationSuccess: true,
        registrationFailed: false,
        verificationLink: _.get(action.payload, 'verificationLink', null),
      };
    case COMPLETE_REGISTRATION_FAILURE:
      return {
        ...state,
        isFetching: false,
        registrationFailed: true,
        errorDetail: _.get(action.payload, 'errorDetail', false),
        statusCode: _.get(action.payload, 'statusCode', false),
        duplicatedEmail: _.get(action.payload, 'duplicatedEmail', false),
      };
    case POLL_EMAIL_VERIFICATION:
      return {
        ...state,
        isPollingEmail: true,
      };
    case POLL_EMAIL_VERIFICATION_SUCCESS:
      return {
        ...state,
        emailVerified: _.get(action.payload, 'emailVerified', false),
      };
    case POLL_EMAIL_VERIFICATION_FAILURE:
      return {
        ...state,
        isPollingEmail: false,
      };
    case STOP_POLL_EMAIL_VERIFICATION:
      return {
        ...state,
        isPollingEmail: false,
      };
    case RESEND_EMAIL_VERIFICATION:
      return {
        ...state,
        isResendingEmail: true,
        resendEmailMessage: '',
        resendEmailMessageIsError: false,
      };
    case RESEND_EMAIL_VERIFICATION_SUCCESS:
      return {
        ...state,
        isResendingEmail: false,
        resendEmailMessage: _.get(action.payload, 'message', ''),
        resendEmailMessageIsError: false,
      };
    case RESEND_EMAIL_VERIFICATION_FAILURE:
      return {
        ...state,
        isResendingEmail: false,
        resendEmailMessage: _.get(action.payload, 'message', ''),
        resendEmailMessageIsError: true,
      };
    case RESEND_EMAIL_COOLDOWN_TICK:
      return {
        ...state,
        resendCooldownRemaining: _.get(action.payload, 'secondsRemaining', 0),
      };
    case RESEND_EMAIL_COOLDOWN_EXPIRE:
      return {
        ...state,
        resendCooldownRemaining: 0,
        resendEmailMessage: '',
        resendEmailMessageIsError: false,
      };
    case INIT_COMPLETE_REGISTRATION:
      return {
        ...state,
        guardChecking: true,
        guardReady: false,
      };
    case FETCH_PROFILE_FOR_COMPLETE_REGISTRATION:
      return {
        ...state,
        guardChecking: true,
      };
    case FETCH_PROFILE_FOR_COMPLETE_REGISTRATION_SUCCESS:
      return {
        ...state,
        guardChecking: false,
        guardReady: true,
        profileFields: _.get(action.payload, 'profileFields', null),
        profilePrefillFailed: false,
      };
    case FETCH_PROFILE_FOR_COMPLETE_REGISTRATION_FAILURE:
      return {
        ...state,
        guardChecking: false,
        guardReady: true,
        profilePrefillFailed: true,
      };
    case FETCH_ADDRESSES:
      return {
        ...state,
        addressAutocompleteIsFetching: true,
      };
    case FETCH_ADDRESSES_SUCCESS:
      const addresses = _.get(action.payload, 'response', false);
      return {
        ...state,
        addressAutocompleteIsFetching: false,
        addresses,
      };
    case FETCH_ADDRESSES_FAILURE:
      const addressErrorDetail = _.get(action.payload, 'errorDetail', false);
      return {
        ...state,
        addressAutocompleteIsFetching: false,
        addressErrorDetail,
      };
    case SELECT_ADDRESS_SUCCESS:
      const {
        address,
        parsedAddress,
      } = action.payload;
      return {
        ...state,
        selectedAddress: address,
        selectedAddressParsed: parsedAddress,
        addressErrorDetail: false,
      };

    case SELECT_ADDRESS_FAILURE:
      const { error } = action.payload;
      return {
        ...state,
        addressErrorDetail: error,
        selectedAddress: false,
        selectedAddressParsed: {},
      };
    case RESET_AUTOCOMPLETE:
      return {
        ...state,
        selectedAddress: false,
        selectedAddressParsed: {},
      };
    default:
      return { ...state };
  }
};
